const { getObjectValue } = require("@root/helpers");

module.exports = {
	// getCustomers: _.debounce(({ commit }, payload) => {
	getCustomers({ commit }, payload) {
		return axios.get("/api/customers", { params: payload });
		// .then(({ data }) => {
		// 	commit(
		// 		'SET_VALUE',
		// 		{
		// 			name: 'quote-builder.customers',
		// 			value: data,
		// 		},
		// 		{ root: true }
		// 	);
		//
		// 	return data;
		// });
	},
	// }, 200),

	postCustomer({ commit }, payload) {
		return axios.post("/api/customers", payload).then(({ data }) => {
			commit("addNewCustomer", data);

			return data;
		});
	},

	updatePart({ commit, dispatch }, payload) {
		// console.log('payload', payload);
		payload.params = {
			part_id: payload.line_item.part_id,
			quantity: payload.quantity,
			additional_params: payload.additional_params
		};

		if (!isNaN(payload.price)) {
			payload.params.price = payload.price;
		}

		return dispatch("updateLineItem", payload);
	},

	updateOption({ commit, dispatch }, payload) {
		let prefix = "";

		if (payload.hasOwnProperty("option_name")) {
			prefix = "option_";
		}

		payload.params = {
			name: payload[`${prefix}name`],
			price: payload[`${prefix}price`]
		};

		return dispatch("updateLineItem", payload);
	},

	updateLineItem({ commit }, payload) {
		const document_number = getObjectValue("document_number", payload);

		return axios
			.patch(
				`/api/documents/${document_number}/line-items/${
					payload.line_item.id
				}`,
				payload.params
			)
			.then(({ data }) => {
				commit(
					"documents/updateLineItem",
					{
						document_number,
						data
					},
					{ root: true }
				);

				return data;
			});
	},

	addRemoveProduct({ dispatch }, payload) {
		payload.params = {
			part_id: payload.params.id,
			quantity: payload.quantity,
			additional_params: payload.additional_params
		};

		return dispatch("addLineItem", payload);
	},

	addOption({ dispatch }, payload) {
		payload.params = {
			name: payload.option_name,
			price: payload.option_price
		};

		return dispatch("addLineItem", payload);
	},

	addLineItem({ commit }, payload) {
		const document_number = getObjectValue("document_number", payload);

		return axios
			.post(
				`/api/documents/${document_number}/line-items`,
				payload.params
			)
			.then(({ data }) => {
				commit(
					"documents/addLineItem",
					{
						document_number,
						data
					},
					{ root: true }
				);

				return data;
			});
	},

	removeLineItem({ commit, rootState }, payload) {
		const line_item = payload.line_item;

		return Vue.swal({
			title: "Are you sure?",
			text: `This product will be removed`,
			type: "warning",
			showCancelButton: true,
			confirmButtonText: `DELETE ITEM`
			// cancelButtonColor: rootState.theme.error
		}).then(result => {
			if (result.value) {
				return axios
					.delete(
						`/api/documents/${payload.document_number}/line-items/${
							line_item.id
						}`
					)
					.then(({ data }) => {
						if (data.success) {
							commit(
								"documents/removeLineItem",
								{
									document_number: payload.document_number,
									id: line_item.id
								},
								{ root: true }
							);

							return data;
						}
					});
			}

			return result;
		});
	},

	searchParts({ commit }, payload) {
		return axios.get("/api/parts", { params: payload.params });
	},

	getParts({ commit }) {
		return axios.get("/api/parts").then(({ data }) => {
			commit(
				"SET_VALUE",
				{
					name: "quote-builder.parts",
					value: data
				},
				{ root: true }
			);

			return data;
		});
	},

	updateIncludeDrawings({ commit }, payload) {
		const document_id = getObjectValue("document_id", payload);

		return axios
			.post(
				`/api/documents/${document_id}/line-items/${
					payload.line_item.id
				}/drawings`,
				{ include_drawings: payload.include_drawings }
			)
			.then(({ data }) => {
				commit("updateLineItemField", {
					id: document_id,
					line_item_id: payload.line_item.id,
					fields: {
						include_drawings: payload.include_drawings
					}
				});

				return data;
			})
			.catch(errors => {
				alert(errors);

				return errors;
			});
	},

	updateCustomerField({ commit }, payload) {
		return axios
			.patch(
				`/api/documents/${payload.id}/${payload.field}`,
				payload.params
			)
			.then(({ data }) => {
				let params = {
					id: data.document.id
				};

				params[payload.field] = data.document[payload.field];

				commit("updateDocumentFields", params);

				return data;
			});
	}
};
